import React, { createContext, useState, useEffect, useContext } from 'react';

const ProductContext = createContext();

export const useProducts = () => useContext(ProductContext);

export const ProductProvider = ({ children }) => {
    const [products, setProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwj6TyZYT922ZAO7XTCWHc5Hd3dvSkxa_vQCoQUTKfXc7cmSdOZhxJ3yQU1KYVQcP-D3g/exec';

                const response = await fetch(GOOGLE_SCRIPT_URL);
                const data = await response.json();

                setProducts(data);
                setLoadingProducts(false);
            } catch (error) {
                console.error("Error fetching products from Google Sheets:", error);
                setLoadingProducts(false);
            }
        };

        fetchProducts();
    }, []);

    return (
        <ProductContext.Provider value={{ products, loadingProducts }}>
            {children}
        </ProductContext.Provider>
    );
};